import { useEffect, useRef, useState } from 'react';

const useScrollIntoView = () => {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const calculateVisibility = () => {
      if (!ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const elementHeight = rect.height;
      const windowHeight = window.innerHeight;

      const topVisible = rect.top > 0 && rect.top < windowHeight;
      const bottomVisible = rect.bottom < windowHeight && rect.bottom > 0;

      let visibleHeight;

      if (topVisible && !bottomVisible) {
        // top part of the element is visible
        visibleHeight = windowHeight - rect.top;
      } else if (!topVisible && bottomVisible) {
        // bottom part of the element is visible
        visibleHeight = rect.bottom;
      } else if (topVisible && bottomVisible) {
        // whole element is visible
        visibleHeight = elementHeight;
      } else {
        // no part of element is visible
        visibleHeight = 0;
      }

      if (visibleHeight > elementHeight * 0.5) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', calculateVisibility);
    window.addEventListener('resize', calculateVisibility);

    return () => {
      window.removeEventListener('scroll', calculateVisibility);
      window.removeEventListener('resize', calculateVisibility);
    };
  }, []);

  return { ref, isVisible };
};

export default useScrollIntoView;
